import { Auth } from 'aws-amplify';

const submitNewPassword = async (email, verificationCode, password) => {
  return Auth.forgotPasswordSubmit(
    email.trim(),
    verificationCode.trim(),
    password
  )
    .then(data => {
      return data;
    })
    .catch(error => Promise.reject(error));
};

export default submitNewPassword;
